/* eslint-disable no-undef */
import React, { createContext, useEffect, useState } from 'react'
import AppContainer from './appContainer'
import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux'
import { persistor, store } from './redux/store'
import { PersistGate } from 'redux-persist/integration/react'
import SpinnerProvider from './context/spinnerContext'
import { GoogleOAuthProvider } from '@react-oauth/google'
import { requestFCMToken } from './firebase'
import { getLocal } from './helper/storage'
import axios from 'axios'

export const AuthContext = createContext(null)

function App() {
  const [loggedin, setloggedin] = useState(false)
  const [fcmToken, setFCMToken] = useState(null)
  const authToken = getLocal('authToken')

  useEffect(() => {
    requestFCMToken()
      .then((token) => {
        if (token) {
          setFCMToken(token)
        }
      })
      .catch((error) => {
        console.error('Error retrieving FCM Token:', error)
      })
  }, [])

  useEffect(() => {
    // Update device token only if both fcmToken and authToken are available
    if (fcmToken && authToken) {
      const payload = { deviceToken: fcmToken }

      const updateDeviceToken = async () => {
        try {
          await axios.post(`${process.env.REACT_APP_API_BASE_URL}/update-device-token`, payload, {
            headers: { Authorization: `Bearer ${authToken}` }
          })
        } catch (error) {
          console.error('Error updating device token:', error)
        }
      }

      updateDeviceToken()
    }
  }, [fcmToken, authToken])

  return (
    <>
      <GoogleOAuthProvider clientId={`${process.env.REACT_APP_GOOGLE_CLIENT_ID}`}>
        <SpinnerProvider>
          <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
              <BrowserRouter>
                <AuthContext.Provider
                  value={{
                    loggedin,
                    setloggedin
                  }}
                >
                  <AppContainer />
                </AuthContext.Provider>
              </BrowserRouter>
            </PersistGate>
          </Provider>
        </SpinnerProvider>
      </GoogleOAuthProvider>
    </>
  )
}

export default App
